import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const nextCheckNumberQueryAtom = createQueryAtomFactory(
  'finance.nextCheckNumber',
  (params: { financialAccountId: string }) => ({
    financeNextCheckNumber: {
      __args: {
        financialAccountId: params.financialAccountId,
      },
    },
  }),
  {
    select: (data): string => data?.financeNextCheckNumber ?? '',
  },
);
